let html = `<div class="notice selector">
    <div class="notice__head">
        <div class="notice__title">{title}</div>
        <div class="notice__time">{time}</div>
    </div>
    
    <div class="notice__descr">{descr}</div>
</div>`

export default html